import React from 'react';
import './DisplayText.scss';

// eslint-disable-next-line react/prop-types
export default function DisplayText({ children, size = 'large' }) {
  return <h1 className={`DisplayText Size-${size}`}>{children}</h1>;
}
